import auth from './services/auth';
import roles from './services/roles';
import user from './services/user';
import users from './services/users';
import events from './services/events';
import rosters from './services/rosters';
import vehicles from './services/vehicles';
import utility from './services/utility';
import options from './services/options';
import tenants from './services/tenants';
import yards from './services/yards';

const services = {
  ...auth,
  ...roles,
  ...user,
  ...users,
  ...events,
  ...rosters,
  ...vehicles,
  ...utility,
  ...options,
  ...tenants,
  ...yards,
};

export * from './api.types';
export default services;
